import { render } from "./NoShowModal.vue?vue&type=template&id=540bd720&scoped=true&ts=true"
import script from "./NoShowModal.vue?vue&type=script&lang=ts"
export * from "./NoShowModal.vue?vue&type=script&lang=ts"

import "./NoShowModal.vue?vue&type=style&index=0&id=540bd720&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\mytransfers-extranet-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540bd720"]])

export default __exports__